import React, {Component} from "react";
import {connect} from "react-redux";
import * as R from "ramda";
import {compose} from "ramda";
import {Card, Divider, List} from "antd";
import AddressLink from "../AddressLink";
import {getCompany} from "../../actions/companies";
import {_UserCustom, UserCustom} from "../Boilerplate/UserCustom";

class CompanyPending extends Component {
  componentDidMount() {
    const { onMount, companyId } = this.props;
    onMount && onMount(companyId);
  }

  render() {
    const { company, admins } = this.props;
    return <div style={{display: 'flex', flexDirection: 'column'}}>
      <div style={{ textAlign: 'center' }}>
        Please wait while a company admin approves your request to join the company.
      </div>
      <br />
      <div style={{display: 'inline-block', margin: 'auto'}}>
        <Card className='company-card-flex' title={company.companyname}>
          <div className='company-card-flex-body'>
            <div className='company-card-flex-info'>
              <h4>Address</h4>
              <AddressLink
                address={{
                  street: [company.address, company.address2].join('\n'),
                  city: company.city,
                  state: company.state,
                  zip: company.zip
                }}
              />
              <Divider/>
              <h4>Company Admins</h4>
              <List dataSource={admins} renderItem={admin => <List.Item><List.Item.Meta title={
                <_UserCustom resource={admin} dataItems={['name', 'email']}/>}/>
              </List.Item>}/>
            </div>
          </div>
        </Card>
      </div>
    </div>;
  }
}

export default compose(
  connect(
    (state, props) => {
      const companyId = R.path(['ui', 'authData', 'companyJoinReq', 'results', 0, 'companyid'], state);
      const company = R.path(['companies', 'data', companyId, 'resource'], state) || {};
      const admins = R.path(['ui', 'authData', 'companyJoinReq', 'results', 0, 'admins'], state);
      return {
        companyId,
        company,
        admins
      };
    },
    (dispatch, props) => {
      return {
        onMount: companyId => dispatch(getCompany(companyId))
      }
    },
  ),
)(CompanyPending);


// WEBPACK FOOTER //
// ./src/components/Security/CompanyPending.js